import React, { useEffect, useState, useMemo, useRef } from "react";
import SmuButton from "../../utils/smu-button/SmuButton";
import { Card, Col, Form, Row } from "react-bootstrap";
import { IconBasket, IconPencilEdit, IconUpload } from "../../icons/Icon";
import SmuBadge from "../../utils/smu-badge/SmuBadge";
import { COLOR_PRIMARY } from "../../constants/colors";
import SmuUserIcon from "../../utils/smu-user-icon/SmuUserIcon";
import EditUser from "../edit-user/EditUser";
import { prepareText } from "../../helpers";
import { toast } from "../../helpers/smu-alerts/smu-lerts";
import loadingGif from "../../assets/images/loading.gif";
import moment from "moment";
import { deleteUser, getUsers, signUp, getUserStores, upsertUserStore, deleteUserStore, uploadCsvMasivo } from "../../api/users";
import { getStores } from "../../api/stores";
import Swal from "sweetalert2";
import _ from "lodash";
import SmuTable from "../../utils/smu-table/SmuTable";
import SmuSearch from "../../utils/smu-search/SmuSearch";

const UsersTable = () => {
  const itemsPerPage = 10;

  const [search, setSearch] = useState("");
  const [username, setUsername] = useState("");
  const [profileId, setProfileId] = useState("");
  const [creating, setCreating] = useState(false);
  const [userToEdit, setUserToEdit] = useState(null);
  const [users, setUsers] = useState([]);
  const [userStores, setUserStores] = useState([]);
  const [stores, setStores] = useState([]);
  const [handleUsers, setHandleUsers] = useState([]);
  const [showFileUpload, setShowFileUpload] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [uploadingCsv, setUploadingCsv] = useState(false);
  const [selectedStoresCreate, setSelectedStoresCreate] = useState([]);
  const [storeSearchTermCreate, setStoreSearchTermCreate] = useState('');
  const [isStoreDropdownOpenCreate, setIsStoreDropdownOpenCreate] = useState(false);
  const dropdownRefCreate = useRef(null);

  const handleGetUsers = () => {
    getUserStores().then(({ data }) => {
      setUserStores(data);
    });
    getStores().then(({ data }) => {
      setStores(data);
    });
    getUsers().then(({ data }) => {
      setUsers(data.users);
    });
  };

  useEffect(() => {
    let _users = users;

    if (!!search && _users.length > 0) {
      _users = _users.filter((_user) => {
        const _search = prepareText(search);
        const name = prepareText(_user.name ?? "");
        const datetime = prepareText(_user.timestamp ?? "");
        const username = prepareText(_user.email ?? "");
        return (
          name.includes(_search) ||
          datetime.includes(_search) ||
          username.includes(_search)
        );
      });
    }

    _users = _.orderBy(_users, ["timestamp"], ["desc"]);

    setHandleUsers(_users);
  }, [users, search]);



  useEffect(() => {
    handleGetUsers();
  }, []);

  useEffect(() => {
    if (profileId == 1) {
      setSelectedStoresCreate([]);
      setStoreSearchTermCreate('');
      setIsStoreDropdownOpenCreate(false);
    }
  }, [profileId]);

  const filteredStoresCreate = stores.filter((s) => {
    const normalizedStoreCode = parseInt(s.codLocal).toString().padStart(4, '0');
    const searchTerm = (storeSearchTermCreate || '').toLowerCase();

    if (/^\d+$/.test(storeSearchTermCreate)) {
      const originalNumericTerm = storeSearchTermCreate;
      const paddedSearchTerm = parseInt(storeSearchTermCreate).toString().padStart(4, '0');
      return (
        normalizedStoreCode.includes(originalNumericTerm) ||
        normalizedStoreCode.includes(paddedSearchTerm)
      );
    }

    return (s.descripcion || '').toLowerCase().includes(searchTerm);
  });

  const handleStoreSelectCreate = (storeId) => {
    setSelectedStoresCreate((prev) => (prev.includes(storeId) ? prev : [...prev, storeId]));
    setStoreSearchTermCreate('');
    setIsStoreDropdownOpenCreate(false);
  };

  const handleRemoveStoreCreate = (storeId) => {
    setSelectedStoresCreate((prev) => prev.filter((id) => id !== storeId));
  };

  const provideAccess = (event) => {
    event.preventDefault();
    if (!username) return;

    if (profileId == 2 && selectedStoresCreate.length === 0) {
      return toast({ icon: "warning", title: "Debe seleccionar al menos una tienda" });
    }

    setCreating(true);
    const _user = users.find((u) => {
      return u.email.toUpperCase() === username.toUpperCase();
    });
    if (!!_user) {
      setCreating(false);
      return toast({
        icon: "warning",
        title: "¡El nombre de usuario ya existe!",
      });
    }

    const newUser = new FormData();

    newUser.append("username", username);
    newUser.append("name", username);
    newUser.append("status", 1);
    newUser.append("admin", profileId == 1);
    newUser.append("user_type", "LDAP");
    

    signUp(newUser)
      .then(({ error }) => {
        if (!!error) throw new Error(error.message);

        setUsers((prevUsers) => [newUser, ...prevUsers]);
        toast({ icon: "success", title: "¡Usuario creado con éxito!" });

        // Only if the user is not an admin and has selected at least one store, and the profile is not 0 (default)
        if (profileId != 1 && selectedStoresCreate.length > 0 && profileId != 0) {
          // Append required fields after successful signup, to avoid altering the signup payload
          newUser.append("formato", process.env.REACT_APP_BRAND);
          newUser.append("idUsuario", username);
          (selectedStoresCreate || []).forEach((id) => newUser.append("idTiendas", id));

          return upsertUserStore(newUser).catch((err) => {
            console.error(err);
          });
        }
      })
      .catch((err) => {
        console.error(err);//toast({ icon: "error", title: err });
      })
      .finally(() => {
        handleGetUsers();
        setUsername("");
        setProfileId("");
        setCreating(false);
        setSelectedStoresCreate([]);
        setStoreSearchTermCreate('');
        setIsStoreDropdownOpenCreate(false);
      });
  };

  const editUser = async (newUser) => {
    if (newUser.values().length <= 0) return;

    if(newUser.get("admin") == true) {
      return deleteUserStore(newUser)
      .then(({ error }) => {
        if (!!error) throw new Error(error.message);
      })
      .catch((err) => {
        console.error(err);//toast({ icon: "error", title: err });
      })
      .finally(() =>
        signUp(newUser)
          .then(({ error }) => {
            if (!!error) throw new Error(error.message);

            setUsers((prevUsers) => {
              return prevUsers.map((u) => {
                return u.username === newUser.username ? newUser : u;
              });
            });
            toast({ icon: "success", title: "¡Usuario actualizado!" });
          })
          .catch((err) => {
            console.error(err);//toast({ icon: "error", title: err });
          })
          .finally(() => handleGetUsers())
      );
    } else {
      return upsertUserStore(newUser)
      .then(({ error }) => {
        if (!!error) throw new Error(error.message);
      })
      .catch((err) => {
        console.error(err);//toast({ icon: "error", title: err });
      })
      .finally(() =>
        signUp(newUser)
          .then(({ error }) => {
            if (!!error) throw new Error(error.message);

            setUsers((prevUsers) => {
              return prevUsers.map((u) => {
                return u.username === newUser.username ? newUser : u;
              });
            });
            toast({ icon: "success", title: "¡Usuario actualizado!" });
          })
          .catch((err) => {
            console.error(err);//toast({ icon: "error", title: err });
          })
          .finally(() => handleGetUsers())
      );
    }
  };

  const handleDelete = (_username) => {
    Swal.fire({
      title: "¿Deseas eliminar este usuario?",
      showCancelButton: true,
      confirmButtonText: "Eliminar",
      confirmButtonColor: COLOR_PRIMARY,
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (!result.isConfirmed) return;

      deleteUser(_username)
        .then(({ error }) => {
          if (!!error) throw new Error(error?.message);
          toast({ icon: "success", title: "Usuario eliminado." });
        })
        .catch((err) => {
          console.error(err);//toast({ icon: "error", title: err });
        })
        .finally(() => {
          handleGetUsers();
        });
    });
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    setSelectedFile(file);
  };

  const handleCsvUpload = () => {
    if (!selectedFile) {
      toast({
        icon: "warning",
        title: "Por favor selecciona un archivo CSV",
      });
      return;
    }

    // Validate file extension
    if (!selectedFile.name.toLowerCase().endsWith('.csv')) {
      toast({
        icon: "warning",
        title: "El archivo debe ser un CSV",
      });
      return;
    }

    setUploadingCsv(true);

    uploadCsvMasivo(selectedFile)
      .then(({ data, error }) => {
        if (!!error) throw new Error(error.message);

        // Check if response indicates errors
        if (data && data.includes("Error:")) {
          toast({
            icon: "error",
            title: "Error en el procesamiento",
          });
        } else {
          toast({
            icon: "success",
            title: "¡Carga masiva completada!",
          });
        }
      })
      .catch((err) => {
        console.error(err);
        toast({
          icon: "error",
          title: "Error al procesar el archivo CSV",
          text: err.message || "Error desconocido",
        });
      })
      .finally(() => {
        // Reset form and refresh data
        handleGetUsers();
        setUsername("");
        setProfileId("");
        setCreating(false);
        setSelectedFile(null);
        setUploadingCsv(false);
        setShowFileUpload(false);
        
        // Reset file input
        const fileInput = document.querySelector('input[type="file"]');
        if (fileInput) {
          fileInput.value = '';
        }
      });
  };

  const columns = [
    {
      name: "",
      cell: () => (
        <div className="cell">
          <SmuUserIcon color="#013e8f" />
        </div>
      ),
      width: "80px",
    },
    {
      name: "Nombre",
      selector: (row) => row.name,
      sortable: true,
      cell: (row) => (
        <div className="cell text-truncate">{row?.name || row.email}</div>
      ),
      width: "25%",
    },
    {
      name: "Username",
      selector: (row) => row.email,
      sortable: true,
      cell: (row) => <div className="cell">{row.email}</div>,
      width: "20%",
    },
    {
      name: "Perfil",
      selector: (row) => row.admin,
      sortable: true,
      cell: (row) => (
        <div className="cell">{(row.admin == true || row.admin == 'true') ? "Admin" : "Usuario"}</div>
      ),
      width: "15%",
    },
    {
      name: "Fecha Validación",
      selector: (row) => row.timestamp,
      sortable: true,
      cell: (row) => (
        <div className="cell">
          {moment(row.timestamp).format("DD-MM-YYYY HH:mm")}
        </div>
      ),
    },
    {
      name: "Tienda asignada",
      sortable: true,
      cell: (row) => {
        if (row.admin == true || row.admin == 'true') return <div className="cell">-</div>;
        const relations = userStores.filter(s => s.idUsuario == row.email).map(s => s.idTiendas);
        const codes = relations
          .map(id => stores.find(st => st.idTiendas == id)?.codLocal)
          .filter(Boolean)
          .map(c => parseInt(c).toString().padStart(4, '0'));
        return (
          <div 
            className="cell text-truncate"
            title={codes.length ? codes.join(', ') : 'Sin tienda asignada'}
            style={{maxWidth: "175px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap"}}
          >
            {codes.length ? codes.join(', ') : 'Sin tienda asignada'}
          </div>
        );
      }
    },
    {
      name: "",
      selector: (row) => row.name,
      cell: (row) => (
        <div className="cell d-flex">
          <SmuButton _className="ms-3" control={() => setUserToEdit(row)}>
            <IconPencilEdit color="#33383F" />
          </SmuButton>
          <SmuButton
            _className="ms-3"
            control={() => handleDelete(row.email)}
          >
            <IconBasket color="#33383F" />
          </SmuButton>
        </div>
      ),
      right: true,
    },
  ];

  return (
    <>
      <EditUser
        user={userToEdit}
        onHide={() => setUserToEdit(null)}
        editUser={editUser}
        stores={stores}
        userStores={userStores}
      />

      <Card className="smu-card">
        <Card.Header className="d-flex flex-column py-4">
          <div className="d-flex align-items-center me-auto">
            <SmuBadge color={COLOR_PRIMARY} />
            <span className="fs-5 ms-3 me-auto">Buscar Usuarios</span>
          </div>
          <Form
            className="smu-form px-5 mx-4 my-5"
            onSubmit={(event) => provideAccess(event)}
          >
            <Row className="d-flex">
              <Col col={12} className="col-5">
                <Form.Control
                  type="search"
                  placeholder="Nombre de usuario"
                  value={username}
                  onChange={(event) => setUsername(event.target.value)}
                  required
                />
              </Col>
              <Col col={12} className="col-4">
                <Form.Select
                  value={profileId}
                  onChange={(event) => setProfileId(event.target.value)}
                >
                  <option value={0}>Seleccionar Perfil*</option>
                  <option value={1}>Admin</option>
                  <option value={2}>Usuarios</option>
                </Form.Select>
              </Col>
              <Col col={12}>
                {!creating ? (
                  <button
                    type="submit"
                    className="smu-generic-button w-100 text-truncate w-100 h-100"
                    disabled={profileId == 2 && selectedStoresCreate.length === 0}
                  >
                    Dar Acceso
                  </button>
                ) : (
                  <div className="smu-generic-button h-100 d-flex">
                    <img
                      src={loadingGif}
                      alt="Cargando"
                      className="m-auto"
                      width={28}
                      height={28}
                    />
                  </div>
                )}
              </Col>
              <Col col={12} className="col-5 mt-3">
                <Form.Label htmlFor="store-create">Tiendas asignadas {profileId == 2 ? "*" : ""}</Form.Label>
                {selectedStoresCreate.length > 0 && (
                  <div className="d-flex flex-wrap gap-2 mb-2">
                    {selectedStoresCreate.map((id) => {
                      const s = stores.find((st) => st.idTiendas == id);
                      const label = s ? parseInt(s.codLocal).toString().padStart(4, '0') : id;
                      return (
                        <span key={id} className="border rounded px-2 py-1 d-flex align-items-center" style={{ fontSize: '12px', gap: '8px' }}>
                          {label}
                          <span role="button" aria-label="Quitar tienda" style={{ cursor: 'pointer' }} onClick={() => handleRemoveStoreCreate(id)}>×</span>
                        </span>
                      );
                    })}
                  </div>
                )}
                <div className="position-relative">
                  <Form.Control
                    type="text"
                    id="store-create"
                    className="text-dark"
                    placeholder={'Seleccionar Tienda'}
                    value={isStoreDropdownOpenCreate ? storeSearchTermCreate : 'Seleccionar Tienda'}
                    onChange={(e) => {
                      setStoreSearchTermCreate(e.target.value);
                      setIsStoreDropdownOpenCreate(true);
                    }}
                    onFocus={() => setIsStoreDropdownOpenCreate(true)}
                    onBlur={(e) => {
                      if (dropdownRefCreate.current && dropdownRefCreate.current.contains(e.relatedTarget)) {
                        return;
                      }
                      setTimeout(() => setIsStoreDropdownOpenCreate(false), 200);
                    }}
                    autoComplete="off"
                    disabled={profileId == 1 || profileId == 0}
                  />
                  {isStoreDropdownOpenCreate && (
                    <div
                      ref={dropdownRefCreate}
                      className="position-absolute w-100 bg-white border border-secondary rounded mt-1"
                      style={{ zIndex: 1000, maxHeight: '200px', overflowY: 'auto' }}
                      onMouseDown={(e) => {
                        const rect = e.currentTarget.getBoundingClientRect();
                        const scrollbarWidth = 17;
                        const isClickingOnScrollbar = e.clientX > rect.right - scrollbarWidth;
                        if (isClickingOnScrollbar) {
                          e.preventDefault();
                          e.stopPropagation();
                        }
                      }}
                    >
                      {selectedStoresCreate.length > 0 && (
                        <div
                          className="px-3 py-2 cursor-pointer border-bottom"
                          style={{ cursor: 'pointer' }}
                          onMouseDown={() => setSelectedStoresCreate([])}
                        >
                          Limpiar selección
                        </div>
                      )}
                      {filteredStoresCreate.map((s) => (
                        <div
                          key={s.idTiendas}
                          className="px-3 py-2 cursor-pointer border-bottom"
                          style={{ cursor: 'pointer' }}
                          onMouseDown={() => handleStoreSelectCreate(s.idTiendas)}
                        >
                          {parseInt(s.codLocal).toString().padStart(4, '0')}
                        </div>
                      ))}
                      {filteredStoresCreate.length === 0 && storeSearchTermCreate && (
                        <div className="px-3 py-2 text-muted">
                          No se encontraron tiendas
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </Col>
              
              
            </Row>
          </Form>
        </Card.Header>
        <Card.Header className="d-flex py-4">
          <div className="d-flex align-items-center me-auto">
            <SmuBadge color={COLOR_PRIMARY} />
            <span className="fs-5 ms-3 me-auto">Usuarios agregados</span>
          </div>
        </Card.Header>
        <Card.Body>
          <Row className="mb-4">
            <Col col={12} xs={3}>
              <button
                type="button"
                className="smu-generic-button w-100"
                onClick={() => setShowFileUpload(!showFileUpload)}
              >
                Carga masiva
              </button>
            </Col>
            <Col col={12} xs={5} className="d-flex align-items-center">
              {showFileUpload && (
                <div className="d-flex align-items-center me-2 w-100">
                  <label
                    htmlFor="csv-file-input"
                    className="smu-generic-button d-flex align-items-center justify-content-center"
                    style={{ 
                      minWidth: '40px',
                      height: '40px',
                      padding: '8px',
                      cursor: 'pointer',
                      marginRight: '8px'
                    }}
                  >
                    <IconUpload color={COLOR_PRIMARY} />
                    <input
                      id="csv-file-input"
                      type="file"
                      accept=".csv"
                      style={{ display: 'none' }}
                      onChange={handleFileChange}
                    />
                  </label>
                  <div className="flex-grow-1 text-truncate" style={{ fontSize: '14px', color: '#6c757d' }}>
                    {selectedFile ? selectedFile.name : 'Seleccionar archivo CSV'}
                  </div>
                </div>
              )}
              {showFileUpload && (
                <button
                  type="button"
                  className="smu-generic-button"
                  style={{ minWidth: '80px' }}
                  onClick={handleCsvUpload}
                  disabled={uploadingCsv || !selectedFile}
                >
                  {uploadingCsv ? (
                    <img
                      src={loadingGif}
                      alt="Cargando"
                      width={16}
                      height={16}
                    />
                  ) : (
                    "Enviar"
                  )}
                </button>
              )}
            </Col>
            <Col col={12} xs={4}>
              <SmuSearch
                value={search}
                onChange={({ target }) => setSearch(target.value)}
              />
            </Col>
          </Row>
          <SmuTable
            columns={columns}
            data={handleUsers}
          />
        </Card.Body>
      </Card>
    </>
  );
};

export default UsersTable;
